import { Form } from 'react-bootstrap';

type SearchProps = React.ComponentProps<typeof Form.Control>;

export const Search = (controlProps: SearchProps) => {
  return <Form.Control type="search" {...controlProps} />;
};
